import { Growl } from "primereact/growl";
import React from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from 'primereact/paginator';
import { Message } from "primereact/message";
import servicioArchivos from '../servicio/ServicioArchivos';
import servicioHttp from "../servicio/ServicioHttp";
import servicioObjetos from '../servicio/ServicioObjetos';
import servicioGeneradorAnios from '../servicio/ServicioGeneradorAnios';

const TODOS = { label: "Todos", value: null };

const MESES = [
    { label: "Enero", value: "Enero" },
    { label: "Febrero", value: "Febrero" },
    { label: "Marzo", value: "Marzo" },
    { label: "Abril", value: "Abril" },
    { label: "Mayo", value: "Mayo" },
    { label: "Junio", value: "Junio" },
    { label: "Julio", value: "Julio" },
    { label: "Agosto", value: "Agosto" },
    { label: "Septiembre", value: "Septiembre" },
    { label: "Octubre", value: "Octubre" },
    { label: "Noviembre", value: "Noviembre" },
    { label: "Diciembre", value: "Diciembre" }];

const ANIOS = servicioGeneradorAnios.generarAnios();

const TIPOS_ARCHIVO = [
    { label: "VISOR", value: "Visor" },
    { label: "SUA", value: "SUA" },
    { label: "PDF", value: "PDF" },
    { label: "EXCEL", value: "Excel" }];

const JOIN_PRINCIPAL = {
    "tcEmpresa": "alias_tcEmpresa"
};

const PAGINACION_INICIAL = {
    registrosPorPagina: 10,
    join: null,
    restriccionesDinamicas: [
    ]
}
export class Descarga extends React.Component {

    constructor() {
        super();
        this.state = {
            paginacion: PAGINACION_INICIAL,
            registrosPatronales: [],
            consulta: {},
            errores: {},
            idsenube: 0
        };
    }

    componentDidMount() {
        this.obtenerRegistrosPatronales();
    }

    obtenerRegistrosPatronales = () => {
        servicioHttp.consumirPostHttp('empresa/obtener_registro_patronal.json').then(response => {
            let registrosPatronales = [TODOS];
            var newArray = registrosPatronales.concat(response.data.lista);
            let { consulta } = this.state;
            consulta.registroPatronal = TODOS.value;
            consulta.mes = TODOS.value;
            consulta.anio = TODOS.value;
            let arregloMeses = [TODOS];
            arregloMeses = arregloMeses.concat(MESES);

            let arregloAnios = [TODOS];
            arregloAnios = arregloAnios.concat(ANIOS);
            let arregloTipoArchivos = [TODOS];
            arregloTipoArchivos = arregloTipoArchivos.concat(TIPOS_ARCHIVO);
            this.setState({ registrosPatronales: newArray, consulta: consulta, meses: arregloMeses, anios: arregloAnios, tipoArchivo: arregloTipoArchivos });
        }).catch(error => {

        });
    };

    consultarEmision = () => {
        let { consulta } = this.state;
        const validacion = this.validarFormulario(consulta);
        this.setState({ errores: validacion });
        if (servicioObjetos.esObjetoVacio(validacion)) {
            this.asignarRestricciones();
            let { paginacion } = this.state;
            servicioHttp.consumirPostHttp('emision/consulta_documentos.json', paginacion).then(response => {
                this.setState({ paginacion: response.data.objeto });
            }).catch(error => {

            });
        }
    }

    asignarValores = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    }

    validarFormulario = (consulta) => {
        const errores = {};
        if (servicioObjetos.esObjetoVacio(consulta.registroPatronal) && servicioObjetos.esObjetoVacio(consulta.mes) && servicioObjetos.esObjetoVacio(consulta.anio)) {
            errores.anio = "Seleccione año";
            errores.mes = "Seleccione mes";
            errores.registroPatronal = "Selecciones un registro patronal";
        }

        if (!servicioObjetos.esObjetoVacio(consulta.mes) && servicioObjetos.esObjetoVacio(consulta.anio)) {
            errores.anio = "Seleccione año";
        }
        return errores;
    };

    asignarRestricciones = () => {
        let { consulta, paginacion ,registrosPatronales } = this.state;
        paginacion.join = JOIN_PRINCIPAL;
        paginacion.restriccionesDinamicas = [];
        if (!servicioObjetos.esObjetoVacio(consulta.registroPatronal)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_tcEmpresa.id",
                valorPropiedad: consulta.registroPatronal
            });
        } else {
            let empresasUsuarioSesion = [];
            for (let index = 0; index < registrosPatronales.length; index++) {
                let elemento = registrosPatronales[index];
                if (!servicioObjetos.esObjetoVacio(elemento.value)) {
                    let valor = elemento.value;
                    empresasUsuarioSesion.push(
                        valor
                    );
                }
            }
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "in",
                nombrePropiedad: "alias_tcEmpresa.id",
                coleccionIn: empresasUsuarioSesion
            });
        }


        if (!servicioObjetos.esObjetoVacio(consulta.anio) && !servicioObjetos.esObjetoVacio(consulta.mes)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "periodo",
                valorPropiedad: consulta.mes + " " + consulta.anio
            });
        }
        if (!servicioObjetos.esObjetoVacio(consulta.anio) && servicioObjetos.esObjetoVacio(consulta.mes)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "like",
                nombrePropiedad: "periodo",
                valorPropiedad: consulta.anio,
                modoLike: "ANYWHERE"
            });
        }
    }
    descargarMasiva = () => {
        this.asignarRestricciones();
        let { paginacion } = this.state;
        let paginacionClon = JSON.parse(JSON.stringify(paginacion));
        paginacionClon.join.ttDocumentosEmisions='alias_ttDocumentosEmisions';
        servicioArchivos.descargaArchivo('emision/descargar_documentos.json', paginacionClon);
    }

    descargarTodos = (event, id) => {
        event.preventDefault();
        this.asignarRestricciones();
        let { paginacion } = this.state;
        let paginacionClon = JSON.parse(JSON.stringify(paginacion));
        paginacionClon.join.ttDocumentosEmisions='alias_ttDocumentosEmisions';
        paginacionClon.restriccionesDinamicas = [];
        paginacionClon.restriccionesDinamicas.push(
            {
                tipoRestriccion: "eq",
                nombrePropiedad: "id",
                valorPropiedad: id
            }
        );
        servicioArchivos.descargaArchivo('emision/descargar_documentos.json', paginacionClon);
    }

    descargaDocumentos = (event, id) => {
        event.preventDefault();
        servicioArchivos.descargaArchivo('documentosemision/descargar.json', { id: id });
    }
    plantillaIdEmaVisor = (rowData, column) => {
        return servicioObjetos.esObjetoVacio(rowData.idEmaVisor) ? null : <div><a href="#" onClick={(e) => this.descargaDocumentos(e, rowData.idEmaVisor)}>
            VISOR
      </a></div>;
    }

    plantillaIdEmaSua = (rowData, column) => {
        return servicioObjetos.esObjetoVacio(rowData.idEmaSua) ? null : <div><a href="#" onClick={(e) => this.descargaDocumentos(e, rowData.idEmaSua)}>
            SUA
  </a></div>;
    }

    plantillaIdEmaPdf = (rowData, column) => {
        return servicioObjetos.esObjetoVacio(rowData.idEmaPdf) ? null : <div><a href="#" onClick={(e) => this.descargaDocumentos(e, rowData.idEmaPdf)}>
            PDF
  </a></div>;
    }

    plantillaIdEbaVisor = (rowData, column) => {
        return servicioObjetos.esObjetoVacio(rowData.idEbaVisor) ? null : <div><a href="#" onClick={(e) => this.descargaDocumentos(e, rowData.idEbaVisor)}>
            VISOR
  </a></div>;
    }

    plantillaIdEbaSua = (rowData, column) => {
        return servicioObjetos.esObjetoVacio(rowData.idEbaSua) ? null : <div><a href="#" onClick={(e) => this.descargaDocumentos(e, rowData.idEbaSua)}>
            SUA
  </a></div>;
    }

    plantillaIdEbaPdf = (rowData, column) => {
        return servicioObjetos.esObjetoVacio(rowData.idEbaPdf) ? null : <div><a href="#" onClick={(e) => this.descargaDocumentos(e, rowData.idEbaPdf)}>
            PDF
  </a></div>;
    }

    plantillaIdEmaExcel = (rowData, column) => {
        return servicioObjetos.esObjetoVacio(rowData.idEmaExcel) ? null : <div><a href="#" onClick={(e) => this.descargaDocumentos(e, rowData.idEmaExcel)}>
            Excel
  </a></div>;
    }

    plantillaDescargaTodos = (rowData, column) => {
        return <div><a href="#" onClick={(e) => this.descargarTodos(e, rowData.id)}>
            Todos
  </a></div>;
    }

    resetFormulario = () => {
        this.setState({ paginacion: PAGINACION_INICIAL, consulta: {}, errores: {} });
        this.obtenerRegistrosPatronales();
    };

    cambiaPagina = (event) => {
        //this.asignarRestricciones();        
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first });
        this.consultarEmision();
    }
    render() {
        let { errores, paginacion, registrosPatronales, consulta, meses, anios, idsenube } = this.state;
        return (
            <div>
                <Growl ref={(el) => (this.growl = el)} />
                <div className="card card-w-title">
                    <h1>Descarga Emisión</h1>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-2">
                            <label >* Registro Patronal:</label>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <Dropdown filter={true} filterPlaceholder="Filtra por RP o Nombre corto" filterBy="value,label" showClear={true}
                            appendTo={document.body} id="consulta.registroPatronal" name="consulta.registroPatronal" 
                            optionLabel="label" options={registrosPatronales} 
                            value={consulta.registroPatronal} 
                            onChange={(e) => this.asignarValores(e, false)} autoWidth={false} style={{ width: "100%" }} />
                            {errores.registroPatronal ? (<div><br /> <Message severity="error" text={errores.registroPatronal} />{" "}</div>) : null}
                        </div>

                        <div className="p-col-12 p-md-1">
                            <label >* Periodo:</label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <Dropdown appendTo={document.body} placeholder="Año:" id="consulta.anio" name="consulta.anio" 
                            optionLabel="label" options={anios} value={consulta.anio} 
                            onChange={(e) => this.asignarValores(e, false)} autoWidth={false} />
                            {errores.anio ? <div><br /> <Message severity="error" text={errores.anio} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-md-2">
                            <Dropdown appendTo={document.body} placeholder="Mes:" id="consulta.mes" name="consulta.mes" 
                            optionLabel="label" options={meses} value={consulta.mes} 
                            onChange={(e) => this.asignarValores(e, false)} autoWidth={false} />
                            {errores.mes ? <div><br /> <Message severity="error" text={errores.mes} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-md-2">
                            <Dropdown options={this.state.tipoArchivo} value={this.state.archivo} 
                            onChange={event => this.setState({ archivo: event.value })} autoWidth={false} />
                            {errores.archivo ? <div><br /> <Message severity="error" text={errores.archivo} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-md-2"><Button label="Limpiar" icon="pi-md-refresh" onClick={this.resetFormulario} /></div>
                        <div className="p-col-12 p-md-2"><Button label="Buscar" icon="pi-md-search" onClick={this.consultarEmision} /></div>
                        <div className="p-col-12 p-md-3">
                            {servicioObjetos.esObjetoVacio(paginacion.datos) ? null : <Button label="Descarga Masiva" icon="pi-md-folder" onClick={this.descargarMasiva} />}
                        </div>
                    </div>
                </div>
                <div className="p-col-12"></div>
                    <div className="card card-w-title">
                        <DataTable value={paginacion.datos} editable={true} responsive={true} header="Descarga de Emisiones" resizableColumns={true}>
                            <Column header="Registro Patronal" field="registroPatronal" autoLayout={true} resizableColumns={true} />
                            <Column header="Periodo" field="periodo" autoLayout={true} resizableColumns={true} />
                            <Column header="Ema VISOR" body={this.plantillaIdEmaVisor} autoLayout={true} resizableColumns={true} />
                            <Column header="Ema SUA" body={this.plantillaIdEmaSua} autoLayout={true} resizableColumns={true} />
                            <Column header="Ema PDF" body={this.plantillaIdEmaPdf} autoLayout={true} resizableColumns={true} />
                            <Column header="Eba VISOR" body={this.plantillaIdEbaVisor} autoLayout={true} resizableColumns={true} />
                            <Column header="Eba SUA" body={this.plantillaIdEbaSua} autoLayout={true} resizableColumns={true} />
                            <Column header="Eba PDF" body={this.plantillaIdEbaPdf} autoLayout={true} resizableColumns={true} />
                            <Column header="Excel" body={this.plantillaIdEmaExcel} autoLayout={true} resizableColumns={true} />
                            <Column header="Descargar" body={this.plantillaDescargaTodos} autoLayout={true} resizableColumns={true} />
                        </DataTable>
                        <Paginator first={idsenube} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina} rowsPerPageOptions={[10, 20, 40, 60, 80, 100]} />
                    </div>
                
            </div>
        );
    }
}